// Module
var code = "\n<div class=\"vn-field4 {{form.htmlClass}}\">\n  <div class=\"header\" ng-class=\"{'sr-only': !showTitle() }\"> <span>{{ form.title }}</span></div>\n  <div class=\"main row\"><span>{{form.schema}}</span>\n    <sf-decorator ng-repeat=\"item in form.items\" form=\"item\"></sf-decorator>\n  </div>\n</div>";
// Exports
export default code;